import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { ContatoEmpresa } from '../../components'
import * as contatoComercializadoraActionCreators from '../../redux/modules/contatoComercializadora'
import * as flashMessageActionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class ContatoComercializadoraContainer extends Component {

  static propTypes = {
    comercializadora: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    multipleContatoComercializadora: PropTypes.object.isRequired,
    fetchMultipleContatoComercializadora: PropTypes.func.isRequired,
    destroyContatoComercializadora: PropTypes.func.isRequired,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    const { comercializadora } = this.props
    await this.props.fetchMultipleContatoComercializadora(comercializadora.id)
  }

  handleRedirectToNew = (comercializadoraId) => {
    this.props.history.push(`/comercializadoras/${comercializadoraId}/contatos/new`)
  }

  handleEditResource = (comercializadoraId, id) => {
    this.props.history.push(`/comercializadoras/${comercializadoraId}/contatos/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyContatoComercializadora(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('contatoComercializadora', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('contatoComercializadora', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleContatoComercializadora.toList().toJSON(),
      'contatoComercializadora',
      [
        'id',
        'nome',
        'funcao.nome',
        'email',
        'telefone',
        'celular',
        'observacoes',
      ],
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <ContatoEmpresa
        empresaTypePath='comercializadoras'
        empresa={this.props.comercializadora}
        multipleContatoEmpresa={this.props.multipleContatoComercializadora}
        onRedirectToNew={() => this.handleRedirectToNew(this.props.comercializadora.id)}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading}
      />
    )
  }
}

function mapStateToProps ({ contatoComercializadora, status, sort, filter }, {comercializadora}) {
  const sortColumn = sort.getIn(['contatoComercializadora', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['contatoComercializadora', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['contatoComercializadora', 'filterText']) || ''

  let map = filterMap(contatoComercializadora, ['nome', 'funcao.nome', 'email', 'telefone', 'celular', 'observacoes'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleContatoComercializadora: map.filter(t => t.get('comercializadora_ids').includes(comercializadora.id)),
    sortColumn,
    sortDirection,
    filterText,
    isLoading: status.getIn(['contatoComercializadora', 'isLoading']),
    error: status.getIn(['contatoComercializadora', 'error']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...contatoComercializadoraActionCreators,
    ...flashMessageActionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContatoComercializadoraContainer))
